var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnInteractiveLine = function SvgIcnInteractiveLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 6.83398C15.75 6.00556 15.0784 5.33398 14.25 5.33398H6.91667C6.08824 5.33398 5.41667 6.00556 5.41667 6.83398V12.834C5.41667 13.6624 6.08824 14.334 6.91667 14.334H12.7894L14.4771 15.2525C15.0282 15.5962 15.75 15.201 15.75 14.5445V12.834V12.5007V6.83398ZM14.75 12.5007V12.834V14.2625L13.2302 13.4354C13.108 13.3688 12.971 13.334 12.8318 13.334H6.91667C6.64052 13.334 6.41667 13.1101 6.41667 12.834V6.83398C6.41667 6.55784 6.64052 6.33398 6.91667 6.33398H14.25C14.5261 6.33398 14.75 6.55784 14.75 6.83398V12.5007Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91663 1.33398C2.0882 1.33398 1.41663 2.00556 1.41663 2.83398V7.83398V8.16732V9.87781C1.41663 10.5344 2.13842 10.9296 2.68956 10.5858L4.37721 9.66732H6.08329V8.66732H4.33479C4.19562 8.66732 4.05867 8.70217 3.93643 8.7687L2.41663 9.59583V8.16732V7.83398V2.83398C2.41663 2.55784 2.64048 2.33398 2.91663 2.33398H10.25C10.5261 2.33398 10.75 2.55784 10.75 2.83398V5.33398H11.75V2.83398C11.75 2.00556 11.0784 1.33398 10.25 1.33398H2.91663Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnInteractiveLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_interactive_line.ad381a8c.svg";
export { ForwardRef as ReactComponent };